import { render } from "./LocalUsers.vue?vue&type=template&id=004b2102&ts=true"
import script from "./LocalUsers.vue?vue&type=script&lang=ts"
export * from "./LocalUsers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__